import { render } from "./ManageItems.vue?vue&type=template&id=f6aa8256"
import script from "./ManageItems.vue?vue&type=script&lang=js"
export * from "./ManageItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__